/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonBtcStakerListByFinalityProviderPkRequest = {
    fp?: string;
    sortField?: BabylonBtcStakerListByFinalityProviderPkRequest.sortField;
    sortDirection?: BabylonBtcStakerListByFinalityProviderPkRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonBtcStakerListByFinalityProviderPkRequest {

    export enum sortField {
        STAKING_VALUE = 'STAKING_VALUE',
        STAKING_COUNT = 'STAKING_COUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

